var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhatsappMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0275 8.5C12.3483 8.5 8.55509 12.2633 8.55509 16.9058C8.55509 18.4463 8.97325 19.8896 9.70221 21.1311H9.7019L8.5 25.5L13.0265 24.3172C14.2181 24.9516 15.5803 25.3118 17.0272 25.3118C21.7065 25.3118 25.4997 21.5485 25.4997 16.9061C25.4997 12.2636 21.7068 8.5 17.0275 8.5ZM20.899 20.3306C20.6292 20.6775 19.8749 20.9849 19.3252 20.965C18.7756 20.9451 18.6708 20.9501 17.3643 20.4744C15.6632 19.8424 14.6516 18.6457 14.1345 18.0137C12.7933 16.3707 12.7107 15.5034 12.7207 14.9979C12.7308 14.4923 12.8957 14.0365 13.2453 13.5654C13.5949 13.0946 13.7999 13.0698 14.3392 13.0598C14.8788 13.0499 14.9286 13.4365 15.0535 13.729C15.0535 13.729 15.4945 14.8056 15.5993 15.0215C15.7042 15.237 15.5918 15.3745 15.5208 15.5084C15.4497 15.6422 15.1386 16.0065 15.015 16.1328C14.8914 16.2592 14.9039 16.4154 14.9937 16.5443C15.0835 16.6732 15.5433 17.3818 15.8479 17.6644C16.4172 18.2491 17.1693 18.6568 17.6898 18.9282C18.1321 19.1549 18.237 19.0025 18.3568 18.854C18.4767 18.7053 18.9152 18.1749 19.0501 18.0116C19.185 17.8479 19.7246 18.1206 20.3888 18.4478C21.0533 18.7748 21.273 18.8841 21.3031 19.013C21.3231 19.7664 21.1682 19.9844 20.8983 20.3315L20.899 20.3306Z",
    fill: "#323232"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhatsappMobile);
export default __webpack_public_path__ + "static/media/whatsapp-mobile.c11e190a4d837ca05b2f51e5d521cf6f.svg";
export { ForwardRef as ReactComponent };